import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Button from "../../components/button";
import IconClose from "../../components/icons/close";
import IconSpinner from "../../components/icons/spinner";
import IconLogo from "../../components/icons/logo";
import Image from "../../components/image";
import { fixExternalLinks, getUrl } from "../../utils/helper";
import { getEventDetails } from "../../redux/selectors/lessons";
import { loadEvent } from "../../redux/actions/lessons";
import { DateTime } from "luxon";

class EventDetails extends Component {
    componentDidMount() {
        this.props.loadEvent(this.props.match.params.slug);
    }

    renderLessons = () => {
        const { event } = this.props;

        if (event.lessons.length === 0) return null;

        return (
            <div className="grid mt-30 pt-30 md:grid-cols-2 xl:grid-cols-3 gap-x-30 gap-y-50 xl:gap-y-60 border-t border-blue">
                {event.lessons.map((item) => (
                    <Link
                        className="flex flex-col text-blue"
                        to={getUrl("lessons/" + item.slug)}
                        title={item.name}
                    >
                        {item.cover && (
                            <Image
                                alt={item.cover.alt || item.name}
                                url={item.cover.url}
                                aspectRatio="aspect-ratio-square"
                                styleExtra="mb-20"
                            />
                        )}
                        <h1 className="font-judge font-bold text-23 mb-12">
                            {item.name.toUpperCase()}
                        </h1>
                        {
                            <div className="border-b border-blue pb-24 flex-1">
                                <p
                                    className={
                                        "font-bold text-17 leading-tight line-clamp-5"
                                    }
                                >
                                    {item.teacher_name}
                                </p>
                            </div>
                        }
                        <div className="flex justify-between pt-10">
                            <p className="font-bold text-17">
                                {item.space.name}
                            </p>
                            <p className="font-bold text-17">
                                {DateTime.fromISO(item.date).toLocaleString(
                                    DateTime.DATE_MED
                                )}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
        );
    };

    renderDate = () => {
        const { event } = this.props;

        let firstDay = null;
        let lastDay = null;
        if (event.lessons.length > 0) {
            event.lessons.forEach((lesson) => {
                let lDate = DateTime.fromISO(lesson.date);
                if (!firstDay || lDate < firstDay) firstDay = lDate;
                if (!lastDay || lDate > lastDay) lastDay = lDate;
            });
        }

        let text = "";
        if (firstDay.month !== lastDay.month) {
            text =
                firstDay.day +
                " " +
                firstDay.monthShort +
                " - " +
                lastDay.day +
                " " +
                lastDay.monthShort;
        } else {
            text =
                firstDay.day + " - " + lastDay.day + " " + firstDay.monthShort;
        }

        if (firstDay === lastDay) {
            text = firstDay.day + " " + firstDay.monthShort;
        }

        return (
            <p className="font-judge font-bold text-30 uppercase text-blue">
                {text}
            </p>
        );
    };

    render() {
        const { event, history } = this.props;

        const className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 z-20";

        if (!event)
            return (
                <div className={className}>
                    <Helmet>
                        <body className="modal-open" />
                    </Helmet>
                    <div className="bg-grey flex flex-col items-center justify-center w-full">
                        <IconSpinner className="animate-spin w-20 xl:w-32 h-20 xl:h-32 text-blue" />
                        <IconLogo
                            className={
                                "w-140 xl:w-208 h-30 xl:h-46 mt-40 text-blue"
                            }
                        />
                    </div>
                </div>
            );

        return (
            <div className={className}>
                <Helmet>
                    <body className="modal-open" />
                </Helmet>
                <div
                    id="containerId"
                    className="bg-grey overflow-y-auto w-full"
                >
                    <div
                        name="elementName"
                        className="pt-30 xl:pt-40 pb-80 px-16 xl:px-50"
                    >
                        <div className="hidden xl:flex justify-end">
                            <Button
                                icon={
                                    <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                }
                                onClick={() => {
                                    history.goBack();
                                }}
                                style={"w-70"}
                            />
                        </div>
                        <div className="xl:flex relative xl:mt-40">
                            <div className="xl:w-2/12" />
                            <div className="xl:w-8/12">
                                {this.renderDate()}
                                <h1 className="font-bold mt-10 text-30 xl:text-60 text-blue">
                                    {event.name}
                                </h1>
                                {event.cover && (
                                    <div className="mt-30">
                                        <Image
                                            alt={event.cover.alt || event.name}
                                            url={event.cover.url}
                                            aspectRatio="aspect-ratio-16/9"
                                        />
                                    </div>
                                )}
                                <div
                                    className="mt-30 article-body leading-tight article-break-word text-17 xl:text-23 text-blue"
                                    dangerouslySetInnerHTML={{
                                        __html: fixExternalLinks(
                                            event.description
                                        ),
                                    }}
                                />
                                {this.renderLessons()}
                            </div>
                            <div className="xl:w-2/12" />
                        </div>

                        <div className="xl:hidden absolute right-16 top-16">
                            <Button
                                icon={
                                    <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                }
                                onClick={() => {
                                    history.goBack();
                                }}
                                style={"w-50"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    locale: state.app.locale,
    event: getEventDetails(state, props.match.params.slug),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadEvent,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDetails);
